import type { SVGProps } from "react";

/* eslint-disable max-len */
export const WorkleapIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="2.5 6 25 17.5" fill="currentColor" {...props}>
            <path
                fill="currentColor"
                d="M21.974 7.577h-.216l-2.193 6.679-2.042-6.481a.281.281 0 0 0-.27-.198h-3.56a.332.332 0 0 0-.317.237l-2.311 7.81-2.202-8.047H4.61l4.105 14.59a.328.328 0 0 0 .314.24h3.769a.281.281 0 0 0 .267-.2l2.567-8.679 1.862 5.798a.333.333 0 0 0 .319.232h3.282a.388.388 0 0 0 .368-.265l3.936-11.715h-3.424Z"
            />
        </svg>
    );
};
